module.exports = "/_next/static/images/ico-calendar-7eace3c77930ebb908cca4ef8e8b3df5.svg";